export const accessStatus = {
    NONE: 0,
    UNAUTHENTICATED: 1,
    AUTHENTICATED_ONLY: 2,
    AUTHORIZED: 3
}

export const apiStatus = {
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    DEFAULT: 'INACTIVE'
}

export const dosageForms = {
    CA: "CAPSULE",
    KA: "CREAM",
    SE: "ELIXIR",
    SU: "EMULSION",
    SG: "ENEMA",
    LL: "LIQUID",
    SK: "LOTION",
    TL: "LOZENGE",
    OC: "OINTMENT",
    PA: "POWDER",
    SS: "SHAMPOO",
    SJ: "SOLUTION",
    QA: "SUPPOSITORY",
    SC: "SUSPENSION",
    ST: "SYRUP",
    TA: "TABLET"
}